export interface HcAudioRecording {
  _id: string;
  url: string;
  originalName: string;
  mimeType: string;
  size: number;
  uploadedAt: Date;
  // Optional fields that may be added in the future
  duration?: number; // in seconds
  uploadedBy?: string; // user ID who uploaded the recording
  metadata?: HcAudioRecordingMetadata;
}

export interface HcAudioRecordingMetadata {
  language?: string;
  quality?: AudioQuality;
  format?: AudioFormat;
  sampleRate?: number;
  bitRate?: number;
  channels?: number;
}

export enum AudioQuality {
  LOW = 'audio.quality.low',
  MEDIUM = 'audio.quality.medium',
  HIGH = 'audio.quality.high',
  ULTRA_HIGH = 'audio.quality.ultra_high'
}

export enum AudioFormat {
  MP3 = 'audio.format.mp3',
  WAV = 'audio.format.wav',
  AAC = 'audio.format.aac',
  OGG = 'audio.format.ogg',
  M4A = 'audio.format.m4a',
  WEBM = 'audio.format.webm'
}

export interface HcAudioRecordingUpload {
  file: File | Blob;
  filename?: string;
  metadata?: Partial<HcAudioRecordingMetadata>;
}

export interface HcAudioRecordingUploadResponse {
  success: boolean;
  audioRecording?: HcAudioRecording;
  error?: string;
  uploadUrl?: string; // URL where the file was uploaded
}
